define('views/modules/calendar/animated-session/exercise/history/exercise-history',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils', 'moment',
    // events
    'services/events/animated-session-events',
    // views
    'views/modules/calendar/animated-session/exercise/weight/history/weight-history-list-item',
    'views/modules/calendar/animated-session/exercise/cardio/history/cardio-history-list-item',
    'views/parts/alert/alert-no-data',
    // templates
    'text!templates/modules/calendar/animated-session/exercise/history/exercise-history.html'
], function(
    // Libs
    _, Backbone, Mustache, U, moment,
    // events
    AnimationEvents,
    // views
    VWeightHistoryListItem,
    VCardioHistoryListItem,
    VAlertNoData,
    // templates
    TExerciseHistory
) {

    var VExerciseHistory = Backbone.View.extend({
        template: TExerciseHistory,
        item: function() {
            return this.model.isWeight() ? VWeightHistoryListItem : VCardioHistoryListItem;
        },

        regions: {
            list: '.history-list',
            alert: '.alert-no-data'
        },

        initialize: function(opt) {
            this.options = opt || {};
            this.profile = this.options.profile;

            var model = this.model;

            _.extend(this, {
                session: opt.session
            });

            this.view = {
                alert: new VAlertNoData({
                    title: 'calendar:No History',
                    subtitle: 'calendar:No History Subtitle',
                    collection: new Backbone.Collection([ //temporaire pour urgence
                        { temp: 5 },
                    ]),
                    caret: false
                })
            };

            this.listenTo(model, 'model:reset', this.onModelReset);
            this.listenTo(AnimationEvents, 'exercises:historyLoaded', this.renderDelayed);
        },

        renderDelayed: function(history) {
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext()));

            this.generateZones();
            var view = this.view,
                zone = this.zone;

            this.history = history;
            this.resetList();

            this.assign(view.alert, zone.$alert);
        },

        renderAll: function() {
            var container = document.createDocumentFragment();

            var colSetsByDate = this.history;

            _.each(colSetsByDate, function(sets, date) {
                var viewElement = this.renderOne(sets, date).el;
                container.appendChild(viewElement);
            }, this);

            this.zone.$list.append(container);

            var alertColl = null;
            if (Object.keys(colSetsByDate).length === 0)
                alertColl = new Backbone.Collection(colSetsByDate[0]);
            else
                alertColl = new Backbone.Collection(colSetsByDate);

            this.view.alert.setCollection(alertColl);

            return this;
        },

        renderOne: function(model, date) {
            var ITEM_CONSTRUCTOR = _.result(this, 'item', false),
                exercise = this.model,
                view = new ITEM_CONSTRUCTOR({
                    session: this.session,
                    date: date,
                    sets: model,
                    exercise: exercise,
                    item: this.options.item
                });

            this.childViews.push(view);
            view.render();

            return view;
        },

        resetList: function() {
            this.zone.$list.empty();
            this.removeChildViews({ defer: true });
            this.renderAll();
        },

        onModelReset: function(model) {
            var COLLECTION_CONSTRUCTOR = _.result(model, 'getCollectionConstructor', false);
            this.collection = new COLLECTION_CONSTRUCTOR(model.getCollection().models);

            this.fetchHistory(this.options.model);
        },

        getCurrentlySelectedUser: function() {
            return this.session.get('user') === "me" || _.isEmpty(this.session.get('user')) ? this.profile.get('_id') : this.session.get('user');
        },

        fetchHistory: function(model) {
            this.session.fetchHistory(this.getCurrentlySelectedUser(), model.get("animatedExercise"));
        }

    });

    return VExerciseHistory;
});

